import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Tables & Charts
import FacilitiesTable from "./components/FacilitiesTable";
import ProductsTable from "./components/ProductsTable";
import InstallationsTable from "./components/InstallationsTable";
import FacilitiesChart from "./components/FacilitiesChart";
import ProductsChart from "./components/ProductsChart";
import InstallationsChart from "./components/InstallationsChart";

// Auth & Management
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import UserManagement from "./components/UserManagement";
import LogoutButton from "./components/LogoutButton";

function Dashboard() {
  const role = localStorage.getItem("role");

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>CCE Dashboard</h1>

      {/* Logout button */}
      <LogoutButton />

      {/* Tables */}
      <FacilitiesTable />
      <ProductsTable />
      <InstallationsTable />

      {/* Charts */}
      <FacilitiesChart />
      <ProductsChart />
      <InstallationsChart />

      {/* Show User Management only for Admins */}
      {role === "admin" && <UserManagement />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Login route */}
        <Route path="/login" element={<Login />} />

        {/* Protected Dashboard route */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
